module.exports = __webpack_public_path__ + "img/17.282ceda7.svg";